import React,{useRef} from 'react'
import {Row,Col} from 'react-bootstrap'
import {useForm} from "react-hook-form"
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {useQuery} from "@apollo/client"
import { useMutation } from '@apollo/client'
import Countdown, {zeroPad} from 'react-countdown'

import { GET_Pytanie} from "../Graphql/query"
import { ZAP_Odpowiedz } from '../Graphql/mutacjon'

const Pytanie  = (props) => {
   const nawigacja = useNavigate()
   const {register, handleSubmit,resetField} = useForm()
   const czas = useRef(Number(30*1000))
   const id        = useSelector((magazyn) => magazyn.opcje)
   const uczestnik = useSelector((magazyn) => magazyn.uczestnik)
   const pyt       = useSelector((magazyn) => magazyn.pytania)

   const [odpowiedz] = useMutation(ZAP_Odpowiedz,{
    onCompleted: dane => {
      resetField("pytania")
      resetField("id_pytania")
      if (props.index < Number(pyt.length - 1))
      {
        props.zmianaIndex(props.index+1)
      }
      else {let url = '/koniec'
      nawigacja(url)}
    }
   })

   const wybor = (dane) => {
    let idOdpowiedzi = dane.pytania
    let idPytanie   = dane.id_pytania
    if (idOdpowiedzi === null) { idOdpowiedzi = 'N'}
    odpowiedz({variables: {
        id_uczestnika: Number(uczestnik.id),
        id_konkursu: Number(id.id_konkursu),
        id_pytania: Number(idPytanie),
        id_odpowiedzi: idOdpowiedzi}})
   }

   const onerror = error => console.log(error)
   const renderer = ({minutes,seconds}) => {
    let klasazegar ='zegar_pier'
    if (seconds < 20) {klasazegar = 'zegar_drug'}
    if (seconds < 10 ) {klasazegar='zegar_trze'}
    return <span className={klasazegar}>{zeroPad(minutes)}:{zeroPad(seconds)}</span>
  }
   const {data,loading,error} = useQuery(GET_Pytanie,{variables:{id_pytania:pyt[props.index].id_pytania},fetchPolicy:'network-only'})
   if (loading) { return <p>Wczytywanie danych</p>} else {props.zmianaIndex(props.index)}
   if (error) { return <p>Błąd połacznia z bazą danych</p>}
   const obj_rezygnacja = {id_odpowiedzi:"N",id_pytania:pyt[props.index].id_pytania,tresc_odpowiedzi:"Rezygnacja z odpowiedzi",tresc_pyt:"W"}
   let tab = data.pytanie.map(pyt => {return pyt})
   tab[5] = obj_rezygnacja
        return(
          <div className='widok_pytanie'>
        <form id='form'>        
          <div className='form-group'>
            <Row className='pytanie'>
              <Col xs={1}></Col><Col xs={2}><h2 className="napis">Pytanie</h2></Col>
              <Col xs={9}>
              <Countdown key={data.pytanie[0].id_pytania} renderer={renderer} date={Date.now() + czas.current} onComplete={handleSubmit(wybor,onerror)}></Countdown>
             </Col>
           </Row>
            <Row>
                <Col xs={1}></Col>
                <Col xs={11}>
                  <p className='pytanie'>{data.pytanie[0].tresc_pyt}</p>
                  <input type="hidden" name="id_pytania" value={data.pytanie[0].id_pytania} {...register("id_pytania")}/>
                  </Col>
            </Row>
            <Row>
              <Col xs={1}></Col>
              <Col xs={11}>
              {tab.map(pytanie => (
                <div className = "form-check" key={pytanie.id_odpowiedzi}>
                <input className="form-check-input" {...register('pytania')} type="radio" name="pytania" id={pytanie.id_odpowiedzi} value ={pytanie.id_odpowiedzi} /> 
                <label className='form-check-label' htmlFor={pytanie.id_odpowiedzi}>{pytanie.tresc_odpowiedzi}</label>
                </div>
              ))
             }
             </Col>
            </Row> 
          </div>
        </form>
        </div>
        )
}

export default Pytanie 